import React, {useState} from 'react';
import {View, Text, TouchableOpacity, StyleSheet} from 'react-native';
import {Color, globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import {isMobile} from '../../../utils/commonMethods';
import LiquidityRightBlock from './LiquidityRightBlock';
import Width from '../../../assets/Width';
import AnimatedNumbers from 'react-native-animated-numbers';
import {
  globalConfigurableData,
  GlobalScreens,
} from '../../../utils/globalConstant';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {setHomeFilterCategory} from '../../home/redux/home.action';
import {useDispatch} from 'react-redux';
import {TabActions} from '@react-navigation/native';

const EventHeaderSection = ({
  eventDetails,
  _eventInfo,
  isYesSelected,
  setIsYesSelected,
  onBtnClick,
  navigation,
  isContestCard,
}) => {
  const dispatch = useDispatch();
  const onTabBtnPress = val => {
    onBtnClick(val);
  };

  const yes_price = eventDetails?.newYCP;
  const no_price = eventDetails?.newNCP;
  const showPrice =
    yes_price >= no_price
      ? yes_price?.toFixed(0)
      : (100 - no_price)?.toFixed(0);

  return (
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 10,
        marginBottom: 15,
      }}>
      {/*<View>*/}
      {/*  <Text*/}
      {/*    style={[*/}
      {/*      globalFontStyle.appFontTitleHead,*/}
      {/*      styles.eventPrice,*/}
      {/*      isYesSelected ? {color: Colors.yesColor} : {color: Colors.noColor},*/}
      {/*    ]}>*/}
      {/*    {isYesSelected ? yes_price || '-' : no_price || '-'}*/}
      {/*  </Text>*/}
      {/*</View>*/}
      <View
        style={[styles.externalBorderStyle, !isMobile() ? {width: 200} : {}]}>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            flex: 1,
          }}>
          <View style={{flexDirection: 'row', alignItems: 'center'}}>
            <AnimatedNumbers
              includeComma
              animateToNumber={parseInt(showPrice)}
              fontStyle={{
                ...globalFontStyle.appBlueHead,
                color: GlobalScreens.Event.yesBtnTxt,
                fontSize: isMobile() ? 24 : 32,
                lineHeight: isMobile() ? 28 : 38,
              }}
            />
            <Text
              style={{
                ...globalFontStyle.appBlueHead,
                color: GlobalScreens.Event.yesBtnTxt,
                fontSize: isMobile() ? 24 : 32,
                lineHeight: isMobile() ? 28 : 38,
              }}>
              %
            </Text>
            <Text
              style={{
                ...globalFontStyle.appFontTitleRegular,
                fontWeight: '500',
                color: GlobalScreens.Event.yesBtnTxt,
                letterSpacing: 0.08,
                fontSize: isMobile() ? 18 : 22,
                lineHeight: isMobile() ? 22 : 28,
                marginLeft: 4,
              }}>
              chance
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default EventHeaderSection;

const styles = StyleSheet.create({
  eventPrice: {
    color: Colors.yesColor,
    marginBottom: 12,
  },
  externalBorderStyle: {
    flex: 1,
    flexDirection: 'row',
    ustifyContent: 'space-between',
  },
  categoryStyle: {
    paddingHorizontal: 10,
    paddingVertical: 8,
    backgroundColor: '#F4F4F4',
  },
});
